import { Button, Form, InputNumber, message } from '@maxtropy/components';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import Title from '../Title';
import { useNavigate } from 'react-router-dom';
import { apiV2MobileRemoteConfigIpPost, apiV2MobileRemoteGetConfigPost } from '@maxtropy/device-customer-apis-v2';

function phoneValid(phone: string): boolean {
  const phoneRegex = /^1[3-9]\d{9}$/;
  return phoneRegex.test(phone);
}

const PhoneConfig = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const watchPhone = Form.useWatch('phoneNumber', form);

  useEffect(() => {
    if (watchPhone && phoneValid(watchPhone)) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [watchPhone]);

  const onFinish = (values: any) => {
    console.log('Success:', values);
    //保存手机号
    apiV2MobileRemoteConfigIpPost({ targetPcIp: values.phoneNumber })
      .then(res => {
        setLoading(false);
        message.success('手机号配置成功');
        navigate('/ip/configuration');
      })
      .catch(err => {
        setLoading(false);
        setErrorMsg(err.message || '连接失败，请重试');
      });
    setLoading(true);
    setErrorMsg('');
  };

  useEffect(() => {
    //获取ip地址配置
    apiV2MobileRemoteGetConfigPost({}).then(res => {
      form.setFieldsValue({ phoneNumber: res.targetPcIp });
    });
  }, []);
  return (
    <>
      <div style={{ overflow: 'hidden', width: '100%' }}>
        <div className={styles.phoneConfig}>
          <div className={styles.ButtonActive} onClick={() => navigate('/ip/configuration')}>
            返回
          </div>
          <Title>配置手机号码</Title>
          <Form form={form} onFinish={onFinish}>
            <Form.Item
              label="手机号码"
              name="phoneNumber"
              rules={[
                { required: true, message: '请输入手机号码' },
                { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的手机号码' },
              ]}
              style={{ marginTop: '22px' }}
            >
              <InputNumber style={{ width: '220px' }} placeholder="请输入手机号码" />
            </Form.Item>
          </Form>
          <div>
            <Button onClick={() => form.submit()} loading={loading} disabled={loading || disabled} type="primary">
              <div style={{ width: '330px' }}> {loading ? '连接中' : '连接服务器'}</div>
            </Button>
            {errorMsg && <span style={{ color: 'red', marginLeft: 16 }}>{errorMsg}</span>}
          </div>
        </div>
      </div>
    </>
  );
};

export default PhoneConfig;
